import { render, staticRenderFns } from "./ReelsExpander.vue?vue&type=template&id=070c08d8&scoped=true"
import script from "./ReelsExpander.vue?vue&type=script&lang=js"
export * from "./ReelsExpander.vue?vue&type=script&lang=js"
import style0 from "./ReelsExpander.vue?vue&type=style&index=0&id=070c08d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c08d8",
  null
  
)

export default component.exports